import axios, { AxiosResponse } from "axios";
import TipoObra from "../models/tipoObra.model";
import { General } from "./general";

export function TipoObrasService(props?: any) {
    const getTipoObras = async (): Promise<AxiosResponse<TipoObra[]>> => {
        return axios.post<TipoObra[]>(`${General.API_URL}/GetTipoObras`);

    }

    return (
        {
            getTipoObras,
        }
    );

}